export enum TICKET_STATUS {
	UNDER_ANALYSIS = 2,
	OPEN = 1,
	RESOLVED = 3,
	CANCELLED = 4
}
